var reCaptchaIdPrefix = "reCaptchaID";
var reCaptchaApi = 'https://www.google.com/recaptcha/enterprise.js?onload=reCaptchaCheck&render=explicit'; // АПИ
var reCaptchaDefaultKey = "6LdjZBMUAAAAAFOU8YJ_ek39k7bpCJFA3LqD3gwo"; // Публичный ключ

/*
 * Поиск элементов капчи
 */
var reCaptchaSearch = function () {
    var selectCaptcha = document.getElementsByClassName('captcha');
    return selectCaptcha.length > 0 ? selectCaptcha : false;
};

/*
 * Визуальная индикация ошибки капчи
 */
var reCaptchaErrorState = function (id, action) {
    try {
        var element = document.getElementById(id);
        if (!element) {
            return false;
        }
        if (action) {
            element.classList.add('captcha-error');
        } else {
            element.classList.remove('captcha-error');
        }
    } catch (e) {
        console.error('reCaptchaErrorState error:', e);
    }
};

/*
 * Обновляем истекшую капчу
 */
var reCaptchaExpired = function (id) {
    var element = id ? document.getElementById(id) : null;
    var visualErrors = element ? element.getAttribute('data-visual-errors') === 'true' : false;
    var useEnterprise = element ? element.getAttribute('data-use-enterprise') !== 'false' : true;

    if (visualErrors && id) {
        reCaptchaErrorState(id, true);
    }

    setTimeout(function () {
        try {
            if (useEnterprise && grecaptcha && grecaptcha.enterprise && grecaptcha.enterprise.reset) {
                grecaptcha.enterprise.reset();
            } else if (grecaptcha && grecaptcha.reset) {
                grecaptcha.reset();
            }
        } catch (e) {
            console.error('reCaptchaExpired reset error:', e);
        }

        if (visualErrors && id) {
            reCaptchaErrorState(id, false);
        }
    }, 200);
};

/*
 * Callback при успешной проверке капчи
 */
var reCaptchaCallback = function (id) {
    console.log('reCaptchaCallback: ' + id);
    if (id) {
        var element = document.getElementById(id);
        var visualErrors = element ? element.getAttribute('data-visual-errors') === 'true' : false;

        if (visualErrors) {
            reCaptchaErrorState(id, false);
        }
    }
};

/*
 * Удаление loader после рендера капчи
 */
var reCaptchaRemoveLoader = function (elementId) {
    var el = document.getElementById(elementId);
    if (el) {
        el.classList.remove('captcha-loading');
    }
};

/*
 * Инициализируем капчи
 */
if (typeof window.reCaptchaCheck === 'undefined') {
    window.reCaptchaCheck = function () {
        var selectCaptcha = reCaptchaSearch();

        if (!selectCaptcha) {
            console.log('reCaptchaCheck: empty');
            return false;
        }

        var captchaPublicKey = reCaptchaDefaultKey;

        if (!captchaPublicKey) {
            console.error('reCaptcha: Public key not found');
            return false;
        }

        for (var k in selectCaptcha) {
            if (typeof selectCaptcha[k] === 'object') {
                // skip if already rendered
                if (selectCaptcha[k].innerHTML.trim() !== "" || selectCaptcha[k].getAttribute('data-rendered') === 'true') {
                    continue;
                }

                var element = selectCaptcha[k];
                var nameID = reCaptchaIdPrefix + "-" + (Math.floor(Math.random() * (10000 - 10 + 1)) + 10);

                element.setAttribute('id', nameID);
                element.setAttribute('data-rendered', 'true');

                // Читаем конфигурацию из data-атрибутов
                var useEnterprise = element.getAttribute('data-use-enterprise') !== 'false';
                var visualErrors = element.getAttribute('data-visual-errors') === 'true';
                var customKey = element.getAttribute('data-key');
                var customCallback = element.getAttribute('data-callback');
                var customExpiredCallback = element.getAttribute('data-expired-callback');

                var data = {};
                data['sitekey'] = customKey || captchaPublicKey;

                // Настраиваем callback'і
                if (customExpiredCallback) {
                    data['expired-callback'] = customExpiredCallback;
                } else if (visualErrors) {
                    // Создаём замыкание для передачи ID
                    data['expired-callback'] = (function(id) {
                        return function() { reCaptchaExpired(id); };
                    })(nameID);
                } else {
                    data['expired-callback'] = 'reCaptchaExpired';
                }

                // Обычный callback (если есть)
                if (customCallback) {
                    data['callback'] = customCallback;
                } else if (visualErrors) {
                    // Создаём замыкание для передачи ID
                    data['callback'] = (function(id) {
                        return function() { reCaptchaCallback(id); };
                    })(nameID);
                }

                // Размер
                var size = element.getAttribute('data-size');
                if (size) {
                    data['size'] = size === 'max-compact' ? 'compact' : size;
                } else {
                    element.setAttribute('data-size', 'max-compact');
                    data['size'] = 'compact';
                }

                // Дополнительные параметры
                var type = element.getAttribute('data-type');
                if (type) {
                    data['type'] = type;
                }

                var theme = element.getAttribute('data-theme');
                if (theme) {
                    data['theme'] = theme;
                }

                try {
                    // Рендерим с правильным API
                    if (useEnterprise && grecaptcha && grecaptcha.enterprise && grecaptcha.enterprise.render) {
                        grecaptcha.enterprise.render(nameID, data);
                    } else if (grecaptcha && grecaptcha.render) {
                        grecaptcha.render(nameID, data);
                    } else {
                        console.error('grecaptcha.render is not available');
                    }

                    // Убираем loader через 500ms после рендера
                    setTimeout(reCaptchaRemoveLoader.bind(null, nameID), 500);

                } catch (e) {
                    console.error('reCaptcha render error:', e);
                    // При ошибке всё равно убираем loader
                    element.classList.remove('captcha-loading');
                }
            }
        }
    }
}
